import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

export class Currency {
  alpha3: string;
  decimals: number;
  name: string;
}

export class Currencies {
  sourceCurrencies: Currency[];
  destinationCurrencies: Currency[];
}

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(private http: HttpClient) {
    if(environment.apiBase.includes('localhost')){
      console.warn('Using local backend. Dont forget to use hosted backend instead');
    }
  }

  getCurrencies(): Observable<Currencies> {
    return this.http.get<Currencies>(`${environment.apiBase}/currencies`);
  }
}
